module.exports = __webpack_public_path__ + "static/img/alipay.6a5964f0.jpg";